import { createSelector } from 'reselect';
import { uniq } from 'lodash';

import { jobBuildsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const reducerById = () => (state = {}, action) => {
  switch (action.type) {
    case jobBuildsActionTypes.success:
      const newState = { ...state };
      Object.keys(action.response).forEach(k => {
        if (newState[k]) {
          newState[k] = uniq(newState[k].concat(action.response[k]));
        } else {
          newState[k] = action.response[k];
        }
      });

      return newState;
    default:
      return state;
  }
};

const jobBuilds = cachedRequestByIdReducer(
  jobBuildsActionTypes,
  'byId',
  ['request'],
  reducerById
);
export default jobBuilds;

const getJobBuildsState = state => state.jobBuilds;
export const buildIdsByJobId = state => getJobBuildsState(state).byId;
export const getBuildIdsByJobId = (state, id) => {
  const result = buildIdsByJobId(state)[id];
  return result ? result : [];
};

export const jobIdsByBuildId = createSelector(
  buildIdsByJobId,
  (buildIdsByJobId) => {
    return Object.keys(buildIdsByJobId).reduce((result, jobId) => {
      const buildIds = buildIdsByJobId[+jobId];
      buildIds.map(id => {
        if (!result[id]) {
          result[id] = [];
        }

        result[id].push(+jobId);
      });

      return result;
    }, {});
  }
);
export const getJobIdsByBuildId = (state, id) => {
  const result = jobIdsByBuildId(state)[id];
  return result ? result : [];
};

export const jobCountsByBuildId = createSelector(
  jobIdsByBuildId,
  (jobIdsByBuildId) => {
    return Object.keys(jobIdsByBuildId).reduce((result, buildId) => {
      result[+buildId] = jobIdsByBuildId[+buildId].length;
      return result;
    }, {});
  }
);

export const jobBuildIds = createSelector(
  buildIdsByJobId,
  (buildIds) => {
    const jobBuildIds = uniq(Object.values(buildIds).flat()).sort((a, b) => a - b);
    return jobBuildIds;
  }
);

export const getJobCountByBuildId = (state, id) => {
  const result = jobCountsByBuildId(state)[id];
  return result ? result : 0;
};


// WEBPACK FOOTER //
// src/reducers/jobBuilds.js